import { render, staticRenderFns } from "./ProductImagesInput.vue?vue&type=template&id=6ca71267&"
import script from "./ProductImagesInput.vue?vue&type=script&lang=ts&"
export * from "./ProductImagesInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports